/* eslint-disable import/prefer-default-export */

import BaseScrollable from "./BaseScrollable";
import useDynamicHeight from "./useDynamicHeight";

// PageTableContainer Base variant
function BaseScrollableContainer(props: {
  children: React.ReactNode;
  customHeight?: string;
  backgroundColor?: string;
  px?: string | number;
  py?: string | number;
  extraclasses?: any;
}) {
  const dynamicHeight = useDynamicHeight([
    "page-header",
    "page-footer",
    "add-scrollclass",
  ]);
  return <BaseScrollable {...props} defaultHeight={`${dynamicHeight}`} />;
}

export { BaseScrollableContainer };
